import React from 'react'; 
import "./community.scss";

import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";

const Community = () => {
  return (
    <div className="community">
        <Navbar/>
        <div className="body">
            <h1>Community</h1>
            <p>
                Text
            </p>
        </div>
        <Footer/>
    </div>
  );
};
export default Community;